// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Im-z","tupacHeader":"Jm-z","tupacHeader2":"Km-z","tupacMenu":"Lm-z","tupacMenu2":"Mm-z","tupacMain":"Nm-z","tupacMain2":"Om-z"};